import React from 'react';
import { ModalsKeys } from 'global';
import { useModal } from 'hooks/useModal';
import { FormInput } from 'components/form';
import { Box, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

interface Props {
  externalDealId: string;
  isUserHaveAccessToInventorySearch: boolean;
  onExternalDealIdChange: (id: string) => void;
}

export const SyncDealInfo = ({ externalDealId, onExternalDealIdChange, isUserHaveAccessToInventorySearch }: Props) => {
  const classes = useStyles();

  const { handleOpen: handleOpenDealSyncModal } = useModal(ModalsKeys.SyncDealInfoDialog);

  return (
    <RenderWithCondition condition={isUserHaveAccessToInventorySearch}>
      <Box className={classes.sync}>
        <FormInput value={externalDealId} placeholder="External Deal Number" onChange={onExternalDealIdChange} />
        <Button variant="outlined" onClick={() => handleOpenDealSyncModal(ModalsKeys.SyncDealInfoDialog)}>
          Sync Deal Information
        </Button>
      </Box>
    </RenderWithCondition>
  );
};

const useStyles = makeStyles({
  sync: {
    gap: '1rem',
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '15rem auto',
  },
});
